// 3rd party imports
import * as React from 'react';

// mobx
import { Program } from 'models';

// ui
import { UitkBadge } from 'uitk-react-badge';

import { LocalizedComponentProps } from '@shared-ui/localization-context';

interface ProgramCardStatusBadgeProps extends LocalizedComponentProps {
  program: Program;
  programStatus: string;
}

export const ProgramCardStatusBadge: React.FunctionComponent<ProgramCardStatusBadgeProps> = ({
  program,
  programStatus,
  l10n,
}) => {
  if (!program.live) {
    return null;
  }

  const statusThemeMap = new Map([
    ['APPROVED', 'badge-approved'],
    ['PENDING', 'badge-pending'],
    ['EXPIRED', 'badge-expired'],
    ['DECLINED', 'badge-declined'],
  ]);

  const getsStatusDetails = (): { badgeText: string | null; theme: string | null } => {
    if (!programStatus) {
      return {
        badgeText: null,
        theme: null,
      };
    }

    const statusTheme = statusThemeMap.has(programStatus) ? statusThemeMap.get(programStatus) : 'badge-approved';
    const statusBadgeText =
      programStatus !== 'UNKNOWN'
        ? l10n.formatText(`programs.cards.content.status_${programStatus.toLowerCase()}`)
        : null;

    return {
      theme: statusTheme,
      badgeText: statusBadgeText,
    };
  };

  const { theme, badgeText } = getsStatusDetails();

  return <>{badgeText && <UitkBadge text={badgeText} className={theme} />}</>;
};
